import { render, staticRenderFns } from "./PackageView.vue?vue&type=template&id=0da299e5"
import script from "./PackageView.vue?vue&type=script&lang=js"
export * from "./PackageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da299e5')) {
      api.createRecord('0da299e5', component.options)
    } else {
      api.reload('0da299e5', component.options)
    }
    module.hot.accept("./PackageView.vue?vue&type=template&id=0da299e5", function () {
      api.rerender('0da299e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/components/AppointDelivery/PackageView.vue"
export default component.exports